export const didElementTouchedTop = (
  className: string,
  callback: (value: boolean) => void,
) => {
  window.addEventListener("scroll", function () {
    const element = document.querySelector(className);

    if (element !== null) {
      const rect = element.getBoundingClientRect();

      if (rect.top <= 70 && rect.bottom >= 70) {
        callback(true);
      } else {
        callback(false);
      }
    }
  });
};
